import { axiosInstance } from '../../../shared/api';
import { setAccessToken } from '../lib';

export async function forgotPasswordRequest(userData) {
	try {
		const response = await axiosInstance.post('auth/forgot-password', userData);
		if (response.status === 200) {
			return response;
		}
	} catch (error) {
		console.error(error);
		return error;
	}
}

export async function newPasswordRequest(userData, token) {
	try {
		const response = await axiosInstance.post('auth/reset-password', {
			token: token,
			new_password: userData.newPassword,
		});
		if (response.status === 200 || response.status === 201) {
			// Check if response contains a token to set
			if (response.data.token) {
				setAccessToken(response.data.token);
			}
			return 'ok';
		}
	} catch (error) {
		console.error(error);
		return error;
	}
}
